<div class="modal-map">
    <div class="modal-map__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-6">
          <app-google-map [params]="maps" (view)="viewProduct($event)" [isSearchFromHomepage]="isSearchFromHomepage" (paramChange)="paramChange()"></app-google-map>
        </div>
        <div class="col-lg-6">
          <div class="modal-map__nav">
            <div>
              <button (click)="handleSearch(row)" *ngFor="let row of [0.2, 1, 2, 5, 'All']">
                {{ row == "All" ? "All" : row < 1 ? row * 1000 + "m" : row + "km" }}
              </button>
            </div>
          </div>
          <div *ngIf="!maps.all && !maps.home && !maps.business">
            <div class="alert alert-warning text-center mb-2" role="alert"><i class="fa-solid fa-checkmark"></i> Please Check Home or Business</div>
          </div>

          <div class="dropdown my-2 mr-2 d-flex justify-content-end filter-map">
            <button class="btn btn-sm btn-light dropdown-toggle" type="button" id="filterDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa-solid fa-filter"></i>
              Filter <span class="badge badge-primary" *ngIf="selectedFilterMap.length > 0">{{ selectedFilterMap.length }}</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="filterDropdown">
              <button class="dropdown-item" *ngFor="let filter of filterMaps" (click)="handleFilterMap(filter)" [class.active]="selectedFilterMap.includes(filter)"><i class="{{ filter.icon }} mr-2"></i> {{ filter.name }}</button>
            </div>
          </div>
        </div>
        <div class="col-lg-12 mb-3">
          <div class="top-btns">
            <ng-container *ngFor="let keywordSubCat of maps.subCategoriesBasedOnKeyWords">
              <ng-container *ngFor="let type of keywordSubCat.subcategoryTypes?.slice(0, showMoreKeywords ? keywordSubCat.subcategoryTypes?.length : 8)">
                <button class="card-sub-cate mr-2 mt-2" [class.active]="selectedTypesId.has(type)" (click)="toggleTypeAndSearch(type)">
                  <span class="card-sub-cate__title">
                    {{ type.name }}
                  </span>
                </button>
              </ng-container>
            </ng-container>
          </div>
          <div class="d-flex w-100 justify-content-center mt-2" *ngIf="maps.subCategoriesBasedOnKeyWords?.length == 1 && maps.subCategoriesBasedOnKeyWords[0].subcategoryTypes?.length > 8">
            <button class="t-btn" (click)="showMoreKeywords = !showMoreKeywords">Show {{ showMoreKeywords ? "Less" : "More" }}</button>
          </div>

          <div class="top-btns">
            <ng-container *ngFor="let subCat of maps.subcats.slice(0, showMoreSubcats ? maps.subcats?.length : 8)">
              <button class="card-sub-cate mr-2 mt-2" [class.active]="selectedSubCatIds.has(subCat.id)" (click)="toggleSubCatAndSearch(subCat)">
                <span class="card-sub-cate__title">
                  {{ subCat.name }}
                </span>
              </button>
            </ng-container>
          </div>
          <div class="d-flex w-100 justify-content-center mt-2" *ngIf="maps.subcats?.length > 8">
            <button class="t-btn" (click)="showMoreSubcats = !showMoreSubcats">Show {{ showMoreSubcats ? "Less" : "More" }}</button>
          </div>
        </div>
        <div class="col-lg-12">
          <div *ngIf="maps.products?.length < 1">
            <div class="alert alert-secondary text-center" role="alert"><i class="fa-solid fa-shopping-cart"></i> No Products Available</div>
          </div>
          <div *ngIf="maps.products?.length > 0" class="modal-map__body">
            <div class="products">
              <common-product-card-view (selected)="productSelectedChanged(row, $event)" [isSelected]="i < 5" (view)="viewProduct($event)" *ngFor="let row of maps.products; index as i" [list]="row" [isCommunityProduct]="true" [isSearch]="true" [filterMapsIcon]="selectedFilterMap"></common-product-card-view>
              <button class="addrecomm-btn" (click)="openRecommendationForm()">+ <small>Recommend a Service Or Promotion</small></button>
            </div>
            <div class="card selectcat-faqs d-flex flex-column w-100 p-4 my-4" style="gap: 0.5em" *ngIf="faqsExist">
              <span style="font-size: 1.2rem; font-weight: bold">FAQ</span>
              <div *ngIf="maps.fetchedFaqs.questionOne && maps.fetchedFaqs.answerOne" (click)="showFAQ(0)">
                <div class="arrow-border">
                  {{ maps.fetchedFaqs.questionOne }}
                </div>
                <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerOne" *ngIf="visibleFAQ[0]"></div>
              </div>

              <div *ngIf="maps.fetchedFaqs.questionTwo && maps.fetchedFaqs.answerTwo" (click)="showFAQ(1)">
                <div class="arrow-border">
                  {{ maps.fetchedFaqs.questionTwo }}
                </div>
                <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerTwo" *ngIf="visibleFAQ[1]"></div>
              </div>

              <div *ngIf="maps.fetchedFaqs.questionThree && maps.fetchedFaqs.answerThree" (click)="showFAQ(2)">
                <div class="arrow-border">
                  {{ maps.fetchedFaqs.questionThree }}
                </div>
                <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerThree" *ngIf="visibleFAQ[2]"></div>
              </div>

              <div *ngIf="maps.fetchedFaqs.questionFour && maps.fetchedFaqs.answerFour" (click)="showFAQ(3)">
                <div class="arrow-border">
                  {{ maps.fetchedFaqs.questionFour }}
                </div>
                <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerFour" *ngIf="visibleFAQ[3]"></div>
              </div>

              <div *ngIf="maps.fetchedFaqs.questionFive && maps.fetchedFaqs.answerFive" (click)="showFAQ(4)">
                <div class="arrow-border">
                  {{ maps.fetchedFaqs.questionFive }}
                </div>
                <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerFive" *ngIf="visibleFAQ[4]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <app-marketplace #marketplace [share]="true"></app-marketplace> -->